// removed by extract-text-webpack-plugin
module.exports = {"confirm-modal":"confirm-modal","modal-body":"modal-body","paragraph":"paragraph","confirm-checkbox":"confirm-checkbox","button-cancel":"button-cancel","button-confirm":"button-confirm","modal-item":"modal-item","confirm-modal-wide":"confirm-modal-wide"};


//////////////////
// WEBPACK FOOTER
// ./src/application/component/modals/component/confirm-modal/confirm-modal.style.sass
// module id = axi+
// module chunks = 0